import { render, staticRenderFns } from "./ObjectListCard.vue?vue&type=template&id=69aab122&"
import script from "./ObjectListCard.vue?vue&type=script&lang=ts&"
export * from "./ObjectListCard.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectListCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VRow})
